module.exports = __webpack_public_path__ + "8718d0b50bf3572578375eab6a464baa.fbx";